import { Component } from 'react';

class Menu extends Component {
  render() {
    return this.props.children;
  }
}

export default Menu;
